import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { BookingService } from '../service/booking.service';
import { HttpService } from '../service/http.service';
import { UserService } from '../service/user.service';
import { ToastMessageService } from '../toast-message.service';
import { BrugesVndBooking } from '../bruges-vnd-booking';

@Component({
  selector: 'app-edit-booking-picture',
  templateUrl: './edit-booking-picture.component.html',
  styleUrls: ['./edit-booking-picture.component.css']
})
export class EditBookingPictureComponent implements OnInit {

  img: any = new Image();
  pictureLoaded: boolean = false;
  canvasBlob!: Blob | null;
  fileToUpload: File | null = null;
  booking!: BrugesVndBooking;

  @ViewChild("myCanvas", { static: true }) myCanvas!: ElementRef;
  context!: CanvasRenderingContext2D;

  ngAfterViewInit() {
    console.log(this.bookingService.booking);
    this.context = (<HTMLCanvasElement>this.myCanvas.nativeElement).getContext("2d")!;
    if (this.booking.studentPicture) {
      this.img.src = URL.createObjectURL(this.booking.studentPicture);
      this.img.onload = () => {
        this.drawResizedImage();
        this.pictureLoaded = true;
      }
    } else {
      this.myCanvas.nativeElement.width = 0;
      this.myCanvas.nativeElement.height = 0;
      this.context.drawImage(this.img, 0, 0, 0, 0);
    }
  }

  constructor(
    private bookingService: BookingService,
    private httpService: HttpService,
    public userService: UserService,
    private messageService: ToastMessageService
  ) { }

  ngOnInit() {
    this.booking = this.bookingService.booking as BrugesVndBooking;
  }

  drawResizedImage(){
    let ratio = this.img.width/this.img.height;
    let adjustedImgWidth = 0;
    let adjustedImgHeight = 0;
    // landscape photo (width > height)
    if(ratio >= 1){
      let maxWidth = 300;
      if(this.img.width > maxWidth){
        adjustedImgWidth = maxWidth;
        adjustedImgHeight = maxWidth / ratio;
        this.myCanvas.nativeElement.width = adjustedImgWidth;
        this.myCanvas.nativeElement.height = adjustedImgHeight;
      } else{
        this.myCanvas.nativeElement.width = this.img.width;
        this.myCanvas.nativeElement.height = this.img.height;
      }
      // portrait photo (height > width)
    } else {
      let maxHeight = 320;
      if(this.img.height > maxHeight){
        adjustedImgHeight = maxHeight;
        adjustedImgWidth = maxHeight * ratio;
        this.myCanvas.nativeElement.width = adjustedImgWidth;
        this.myCanvas.nativeElement.height = adjustedImgHeight;
      }  else {
        this.myCanvas.nativeElement.width = this.img.width;
        this.myCanvas.nativeElement.height = this.img.height;
      }
    }
    this.context.drawImage(this.img, 0, 0, this.myCanvas.nativeElement.width, this.myCanvas.nativeElement.height);
  }

  
  handleFileInput(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.fileToUpload = event.target.files[0];
      let reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event: any) => {
        this.img.src = event.target.result;
        this.img.onload = () => {
          const sizeRatio = this.img.width / this.img.height;
          let resizedHeight = this.img.height;
          let resizedWidth = this.img.width;

          if (sizeRatio < 1 && 300 < this.img.height) {
            resizedHeight = 300;
            resizedWidth = 300 * sizeRatio;
          }
          if (sizeRatio >= 1 && this.img.width > 320) {
            resizedWidth = 320;
            resizedHeight = 320 / sizeRatio;
          }

          this.myCanvas.nativeElement.width = resizedWidth;
          this.myCanvas.nativeElement.height = resizedHeight;
          this.context.drawImage(this.img, 0, 0, resizedWidth, resizedHeight);
        }
      }
    }
  }

  uploadFile(){
    let formToSend = new FormData();
    formToSend.append("file", this.canvasBlob!, this.bookingService.booking.id!.toString());
    this.httpService.postStudentPicture(formToSend, this.bookingService.booking.uuid!)
    .subscribe(() => {
      this.fileToUpload = null;
      this.pictureLoaded = true;
      this.messageService.addSuccess("Success", "Picture uploaded");
    }, 
    error =>{
      this.pictureLoaded = false;
      this.fileToUpload = null;
      this.messageService.addError("Error", "Picture not uploaded");
    }
  );
}

updateFile(){
  let formToSend = new FormData();
  formToSend.append("file", this.canvasBlob!, this.bookingService.booking.id!.toString());
  this.httpService.putStudentPicture(formToSend, this.bookingService.booking.uuid!)
  .subscribe(picture => {
      this.fileToUpload = null;
      this.pictureLoaded = true;
      this.canvasBlob = null;
      this.messageService.addSuccess("Success", "Picture is updated");
  }, 
  error =>{
    this.fileToUpload = null;
    this.messageService.addError("Error", "Picture not updated");
  }
);
}

}
